export default {"src":"/_next/static/media/favicon.92674c49.ico","height":48,"width":48};